﻿//CHANGES
import ActivePage from "../activePage";
import * as pageHelper from "../pageHelper";

export default class BusinessUnitPage extends ActivePage {

    constructor() {
        super();
    }

    valueMapper = (options, url) => {
        if (!url)
            url = $("body").data("base-url") + "/Shared/BusinessUnit/ValueMapper";

        $.ajax({
            url: url,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    initialize() {
        this.editableGrids = [];

        $(document).ready(() => {

        });

    }
}





